import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Coins, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export default function Credits() {
  const [packs, setPacks] = useState([]);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    api.get("/credits/packs").then((r) => setPacks(r.data)).catch(() => {});
    api.get("/credits/balance").then((r) => setBalance(r.data.credits)).catch(() => {});
  }, []);

  const buy = async (id) => {
    setLoading(id);
    try {
      const { data } = await api.post("/credits/checkout", { pack: id, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch { toast.error("Paiement impossible"); setLoading(null); }
  };

  return (
    <div className="space-y-6" data-testid="credits-page">
      <div><p className="font-mono text-xs uppercase tracking-[0.2em] text-gold-400">Crédits</p>
        <h1 className="mt-1 font-display text-3xl font-bold tracking-tight">Rechargez à l'usage</h1></div>

      <div className="flex items-center gap-3 rounded-2xl border border-gold-500/30 bg-gold-500/10 p-5">
        <Coins className="h-6 w-6 text-gold-400" />
        <div><p className="text-sm text-muted-foreground">Solde actuel</p><p className="font-display text-3xl font-bold text-gold-400" data-testid="credits-balance">{balance.toLocaleString("fr-FR")} crédits</p></div>
      </div>

      <div className="grid gap-4 sm:grid-cols-3">
        {packs.map((p, i) => (
          <div key={p.id} data-testid={`pack-${p.id}`} className={`flex flex-col rounded-2xl border p-6 ${i === 1 ? "border-gold-500 glow-emerald" : "border-border"} bg-card`}>
            {i === 1 && <span className="mb-2 w-fit rounded-full bg-gold-500 px-2 py-0.5 font-mono text-[10px] font-semibold uppercase text-black">Populaire</span>}
            <h3 className="font-display text-lg font-bold">{p.label}</h3>
            <p className="mt-2 font-display text-4xl font-bold text-gold-400">{p.credits.toLocaleString("fr-FR")}<span className="text-base text-muted-foreground"> crédits</span></p>
            <p className="mt-1 text-sm text-muted-foreground">{(p.amount / 100).toFixed(0)} € · {(p.amount / p.credits / 100).toFixed(3)} €/crédit</p>
            <Button onClick={() => buy(p.id)} disabled={loading === p.id} data-testid={`buy-${p.id}`} className="mt-5 rounded-full bg-gold-500 text-black hover:bg-gold-400">
              {loading === p.id ? <Loader2 className="h-4 w-4 animate-spin" /> : "Recharger"}
            </Button>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border border-border bg-card p-5 text-sm text-muted-foreground">
        <p className="mb-2 font-display font-semibold text-foreground">Grille de consommation</p>
        <div className="flex items-center gap-2"><Check className="h-4 w-4 text-gold-400" />Modèles texte — <span className="font-mono">1 à 4 crédits</span> / appel</div>
        <div className="flex items-center gap-2"><Check className="h-4 w-4 text-gold-400" />Génération image — <span className="font-mono">5 crédits</span></div>
        <div className="flex items-center gap-2"><Check className="h-4 w-4 text-gold-400" />Génération vidéo — <span className="font-mono">25 crédits</span></div>
        <p className="mt-3 text-xs">Le coût exact dépend du modèle choisi · vos crédits n'expirent jamais · paiement sécurisé Stripe (carte test 4242 4242 4242 4242)</p>
      </div>
    </div>
  );
}
